import { Attributes, Misc, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateFileSpecCommand extends ModelBase {

    public staticFileSpecId: number = 0;
    
    public fileType: string = "";

    public enumFileExtension: string = "";

    public enumFileDelimiter: string = "";

    public description: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeEndDate: Date | null = null;

    public rawDataTableName: string = "";

    public rawGenericTableName: string = "";

    public errorHoldingTableName: string = "";

    public columnCount: number = 0;

    public hasCheckConstraintInd: boolean = false;

    public startColumnHeaderRead: number = 0;

    public containHeaderInd: boolean = false;

    public isSingleFileInd: boolean = false;

    public isIgnoredInd: boolean = false;
}